module.exports = __webpack_public_path__ + "static/cadaver_collector-b8b9f147f794d1e72f97e3cbc3759057.png";